<template>
    <div :id="this.$route.name">
        <card back >
            <template v-slot:header>
                <h4 class="d-inline">فیلتر اطلاعات</h4>
                <hr>
            </template>
            <template v-slot:content>
                <div class="row">
                    <div class="col-lg-2 col-12">
                        <date-picker color="dimgray" v-model="tarixAz" clearable :editable="true"
                            placeholder="از تاریخ "></date-picker>
                    </div>
                    <div class="col-lg-2 col-12">
                        <date-picker color="dimgray" v-model="tarixTa" clearable :editable="true"
                            placeholder="تا تاریخ "></date-picker>
                    </div>
					<div class="col-md-2 col-12 mt-1">
					    <div class="custom-control custom-switch">
					        <input type="checkbox" class="custom-control-input InputText" id="ActionDelete"  v-model="ActionDelete" >	
                            <label class="custom-control-label" for="ActionDelete">عملیات حذف</label>
					    </div>
					</div>
					<div class="col-md-2 col-12 mt-1">
					    <div class="custom-control custom-switch">
					        <input type="checkbox" class="custom-control-input InputText" id="ActionUpdate"  v-model="ActionUpdate" />
					        <label class="custom-control-label" for="ActionUpdate">
					            عملیات ویرایش
					        </label>
					    </div>
					</div>
                    <div class="col-lg-2 col-12">
                        <button class="btn btn-success m-1 float-left" dir="ltr" @click.prevent="Search"> <span class="mr-2">
                                جستجو </span><span class="fas fa-search"></span> </button>
                    </div>
                </div>
               
            </template>
        </card>
        <card tools toolsColumns>
            <template v-slot:header>
                <h4 class="d-inline">اطـلاعـات فـرم هـا</h4>
                <hr>
                <bnp-grid v-if="$store.state.renderComponentGrid && IsLoad" :Sortable="true" :propsColumn="Column" :propsRows="rows" :action="true" >
                    <template slot="action-slot" slot-scope="props">
                    <a  href="javascript:;" class="mr-2 badge" @click="OnDetail(props.props); "><h6><span class="fas fa-info text-info hover-danger" ></span></h6></a>
                </template>
                </bnp-grid>
            </template>
        </card>

        <modal v-if="$store.state.Modal"      :InheritanceTheme="true"      :IsFooter="false"      :Size="'Md'">
          <template  v-slot:body>
            <div class="row p-5" dir="rtl" v-if="modal1">
                <div class="col-md-12">
                    <bnp-grid v-if="$store.state.renderComponentGridModal" :propsColumn="ColumnRiz" :propsRows="rowsRiz" :hasRowNum="true" :Selectable="false"  >

                </bnp-grid>
                </div>
                
            </div>
          </template>

          <template v-slot:footer> </template>
        </modal>
    </div>
</template>
<script>
import Modal from '@/pages/Modal/Modal.vue';
    import VuePersianDatetimePicker from "vue-persian-datetime-picker";
    import Card from '@/components/Card/Card.vue'
import BnpGrid from "@/components/BnpGrid/BnpGrid.vue";
    export default {
        components: {
    Card,
    datePicker: VuePersianDatetimePicker,
    BnpGrid,Modal
},
        data() {
            return {
                modal1:false,
                IsLoad:false,
                ActionDelete:false,
                ActionUpdate:true,
                tarixAz: null,
                tarixTa: null,
                Column:[],
                rows:[],
                ColumnRiz:[],
                rowsRiz:[],
                DataAxios_GetData: {
                ArryfildValue: {},
                Method: "post",
                Action: "UserLogInformation",
                Token: this.$session.get("Token"),
            },
            DataAxois: {ArryfildValue: {},Method: "post",Action: "ReadGridColumns",},
            DataAxoisLogRiz: {
                ArryfildValue: {
                SoftwareId: 2,
                UserId: 1,
                FormName: "frmUserLogInformationRiz",
                ShowView: 0,
                },
                Method: "post",
                Action: "ReadGridColumns",
            },
            DataAxios_GetdatRiz:{}
            }
        },
        methods:{

            Search(){
                this.rows=[]
                this.DataAxios_GetData.ArryfildValue = {
                    UserNameFamily: null,
                    dpkLogDateAz: this.tarixAz,
                    dpkLogDateTa: this.tarixTa,
                    chkDeleted: this.ActionDelete==true?'1':'0',
                    chkUpdated: this.ActionUpdate==true?'0':'1',
                    cmbFormId: null,
                    txtFkID: 0,
                    tblShobeId: this.$session.get("UserInfo").tblShobeId,
                    };
                     this.$PostData(this.DataAxios_GetData).then((data) => {
                        if(data.length>0){
                            let list = [];
                            if(this.ActionUpdate&&this.ActionDelete){
                            list=data;
                            }
                            else{
                                if(this.ActionDelete){
                                    list=data.filter((i)=>i.IsDelete=='حذف شده')
                                }
                                if(this.ActionUpdate){
                                    list=data.filter((i)=>i.IsDelete=='اصلاح شده')
                                }
                            }
                             this.rows=list;  
                        }
                        else{
                            this.rows=[]
                        }                                            
                     }).finally(()=>{
                        this.$store.state.renderComponentGrid = false;
                        this.$nextTick(() => {
                            this.$store.state.renderComponentGrid = true;
                            this.IsLoad=true
                        });
                     });
            },
            OnDetail(row){
                // this.$bvModal.show('modal-UserLogInformation');
                
                 this.$GetColumns(this.DataAxoisLogRiz, true)
                    .then((data) => {
                    this.ColumnRiz=data;
                    
                    }).finally(()=>{
                        this.DataAxios_GetdatRiz.Action = "UserLogInformationRiz";
                        this.DataAxios_GetdatRiz.ArryfildValue = {
                        BnpCashLogId: row.Id,
                        };
                        this.DataAxios_GetdatRiz.Method = "post";
                        this.$PostData(this.DataAxios_GetdatRiz).then((data) => {
                        if (data.length > 0) {
                            this.rowsRiz = data;
                        } else {
                            console.log("No Data");
                        }
                         this.$store.state.renderComponentGridModal = false;
                                this.$nextTick(() => {
                                    this.$store.state.renderComponentGridModal = true;
                        });
                        }).finally(()=>{
                            
                                    this.modal1=true
                                    this.$store.state.Modal=true
                        })
                        
                    });
            }
        },
         beforeMount(){
      this.DataAxois.ArryfildValue={SoftwareId: 2,UserId: 1,FormName: "frm" + this.$route.name,ShowView: 0,};
           this.$GetColumns(this.DataAxois, true)
        .then((data) => {
          this.Column=data;
        }).finally(()=>{
            this.$store.state.renderComponentGrid = false;
            this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true;
            });
        });
        
    },
    mounted(){
        this.$GetColumns(this.DataAxoisLogRiz, true)
        .then((data) => {
        this.ColumnRiz=data;});
    }
    }
</script>
<style>
    .vpd-icon-btn {
        padding: 9px !important;
    }
    .vpd-content{
        background: var(--sidebar-action-bg) !important;
        color: var(--sidebar-color-item) !important;
    }
    .vpd-header{
       background: var(--sidebar-action-bg) !important;
        color: var(--sidebar-color-item) !important;
    }

</style>